const semver = require('semver');

module.exports = semver.satisfies(process.version, '>=16.9.0');



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsonwebtoken/lib/rsaPssKeyDetailsSupported.js
// module id = 1455
// module chunks = 21